module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "page-sidebar",
    attrs: {
      "data-pages": "sidebar"
    }
  }, [_c('div', {
    staticClass: "sidebar-header"
  }, [_c('div', {
    staticClass: "brand",
    domProps: {
      "innerHTML": _vm._s(_vm.brand)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sidebar-header-controls"
  })]), _vm._v(" "), _c('div', {
    staticClass: "sidebar-menu"
  }, [_c('ul', {
    staticClass: "menu-items"
  }, [_vm._t("default")], 2), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1120589f"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/side_panel.vue
// module id = 1280
// module chunks = 1